// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__R7sXj","toolbar":"Footer_toolbar__q3vfJ","label":"Footer_label__ZmX3n"};